var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"container lnb d_container"},[_c('div',{staticClass:"contents_wrap no_height"},[_c('div',{staticClass:"contents list-container"},[_c('div',[_vm._v("nickname 상세정보")]),_c('member-detail-component',{attrs:{"member-type":`curatorDetail`}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }